import { useModal } from '../contexts';
import Modal from './Modal';
import { WorkflowFolder } from '../interfaces';

interface Props {
  folder: WorkflowFolder;
  deleteFolder: (id: string) => void;
}

function FolderDeleteModal(props: Props) {
  const { closeModal } = useModal();

  return (
    <Modal
      title={
        <h3 className="font-gilroy font-bold text-red text-xl">
          Delete Folder
        </h3>
      }
      subtitle="This will NOT delete the workflows within the folder."
      secondaryButtonProps={{ text: "Cancel", onClick: closeModal }}
      primaryButtonProps={{ className: "btn-red", text: "Confirm", onClick: () => props.deleteFolder(props.folder.id) }}
      size='sm'
    />
  );
}

export default FolderDeleteModal;
